import {Enum} from "~/enums/index";

export default new Enum({
    CORRECT: "CORRECT",
    FALSE_POSITIVE: "FALSE_POSITIVE",
    MISSED: "MISSED",
    UNKNOWN: "UNKNOWN",
});
